// Module
var code = "<div> <div id=\"shadowDiv\" style=\"display:none\"></div> <div id=\"mainComms\"></div> <div id=\"mainNavigation\"></div> <div id=\"mainContent\" class=\"container\"></div> <div id=\"subContent\"></div> <div id=\"mainFooter\"></div> </div> ";
// Exports
export default code;